import {
  Link,
  TypographyText,
} from "@portal/BaseComponents/Typography/AntTypography";
import { Col, Row } from "antd";
import { TextColumnProps } from "./type";

function TextColumn(props: TextColumnProps) {
  const {
    text,
    suffix,
    prefix,
    type,
    onClickCallback,
    textRenderer,
    textProps,
    linkProps,
    style,
  } = props;
  if (textRenderer) return <>{textRenderer}</>;

  function getTextComponent() {
    if (type === "Link") {
      return (
        <Link onClick={onClickCallback} {...linkProps}>
          {text}
        </Link>
      );
    }

    return (
      <TypographyText
        onClick={onClickCallback}
        ellipsis={{ tooltip: text }}
        {...textProps}
      >
        {text}
      </TypographyText>
    );
  }

  const Component = getTextComponent();
  return (
    <Row align="middle" justify="space-between" style={style} wrap={false}>
      {prefix ? <Col>{prefix}</Col> : null}
      <Col> {Component}</Col>
      {suffix ? <Col>{suffix}</Col> : null}
    </Row>
  );
}

export { TextColumn };
